// Shared head/meta values, applied by meta-manager.js.
//
// app.vue renders the site-wide defaults; page components return
// pageMeta({...}) from their metaInfo() to override single tags. Every tag
// carries a vmid so a page override replaces the default instead of adding a
// duplicate. Empty values are skipped so the default stays in place until the
// CMS response has arrived.

export const SITE_URL = 'https://hochspannung.ch';
export const SITE_NAME = 'Hochspannung';
export const DEFAULT_TITLE = 'Hochspannung – Werbeagentur Zürich';
export const DEFAULT_DESCRIPTION = 'Die Werbeagentur im Herzen der Stadt Zürich, gegründet 2003 von Alexander Taiganidis und Matthew Katumba bietet Werbung, Online, Corporate und Editorial Kommunikations- und Marketing-Massnahmen im Consumer- und B2B-Bereich.';
export const DEFAULT_IMAGE = `${SITE_URL}/hochspannung_560px.png`;

function stripTags(html) {
  return String(html || '').replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
}

export function pageTitle(...parts) {
  const clean = parts.map(stripTags).filter(Boolean);
  if (!clean.length) return '';
  return `${clean.join(' – ')} – ${SITE_NAME}`;
}

export function pageMeta({ title, description, image, path, type } = {}) {
  const meta = [];
  const push = (vmid, attrs) => meta.push({ vmid, ...attrs });

  const cleanTitle = stripTags(title);
  const cleanDescription = stripTags(description);
  const url = path !== undefined ? `${SITE_URL}${path}` : '';

  if (cleanTitle) {
    push('og:title', { property: 'og:title', content: cleanTitle });
    push('twitter:title', { property: 'twitter:title', content: cleanTitle });
  }
  if (cleanDescription) {
    push('description', { name: 'description', content: cleanDescription });
    push('og:description', { property: 'og:description', content: cleanDescription });
    push('twitter:description', { property: 'twitter:description', content: cleanDescription });
  }
  if (image) {
    push('og:image', { property: 'og:image', content: image });
    push('twitter:image', { property: 'twitter:image', content: image });
  }
  if (url) {
    push('og:url', { property: 'og:url', content: url });
    push('twitter:url', { property: 'twitter:url', content: url });
  }
  if (type) {
    push('og:type', { property: 'og:type', content: type });
  }

  const info = { meta };
  if (cleanTitle) info.title = cleanTitle;
  if (url) info.link = [{ vmid: 'canonical', rel: 'canonical', href: url }];
  return info;
}
